import {BaseService} from "./base.service";

class ApikeyService extends BaseService {

    constructor() {
        super('api/apikeys')
    }

}

export const apiKeyService = new ApikeyService();
